module.exports = __webpack_public_path__ + "static/media/easi6_privacy_en.a778eecd.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/easi6_privacy_en.md
// module id = 57
// module chunks = 0